// The selected throwable (G throws it, T / L3 / the touch cycle button switches). Client-side only: the choice rides on the
// throw request and the server validates it and the count. Remembered per browser as a convenience.
import { THROWABLES, isThrowKind, nextThrowable, type Character, type ThrowKind } from '../../common/src/rules';

const KEY = 'nk.throwable';
export const THROW_ICON: Record<ThrowKind, string> = { star: '✦', smoke: '☁', emp: '⚡' };

export class ThrowSel {
  private kind: ThrowKind = (() => { try { const v = localStorage.getItem(KEY); return isThrowKind(v) ? v : THROWABLES[0].id; } catch { return THROWABLES[0].id; } })();
  private count = (c: Character, k: ThrowKind) => c[THROWABLES.find(t => t.id === k)!.field] ?? 0;
  /** What G throws now: the selection, or the next owned throwable when the selected one has run out. */
  current(c: Character): ThrowKind { return this.count(c, this.kind) > 0 ? this.kind : nextThrowable(c, this.kind); }
  cycle(c: Character): ThrowKind {
    this.kind = nextThrowable(c, this.current(c));
    try { localStorage.setItem(KEY, this.kind); } catch { /* storage blocked: this visit only */ }
    return this.kind;
  }
  info(c: Character) { const k = this.current(c), t = THROWABLES.find(x => x.id === k)!; return { kind: k, name: t.name, short: t.short, count: this.count(c, k) }; }
}
